import { TranslationFunction } from 'i18next';
import * as React from 'react';
import { translate } from 'react-i18next';
import AppInsightsService from '../app-insights/service';
import { LANGUAGE_CODE_EN_CA } from '../constants';
import { default as i18n, getDocumentTitle } from '../locales';
import { MIXPANEL_PROPERTY_PAGE_TITLE } from '../mixpanel.service';
import * as AppUtils from '../utils';
import { NavMenu } from './nav-menu';
import { RouterNavLinkProps } from './router-nav-link';

interface SiteNavbarComponentProps {
  t: TranslationFunction;
  onClick?: {
    [key: string]: React.MouseEventHandler<HTMLAnchorElement>;
  };
  children?: void;
}

class SiteNavbarComponent extends React.PureComponent<SiteNavbarComponentProps> {
  constructor(props: SiteNavbarComponentProps) {
    super(props);

    this.onNavLinkClick = this.onNavLinkClick.bind(this);
  }

  public render(): React.ReactNode {
    const navMenu = this.props.t('siteNavbar.menu') as { [key: string]: RouterNavLinkProps };
    Object.keys(navMenu).forEach((key) => {
      const navLinkProps = navMenu[key];
      navLinkProps['data-key'] = key;
      navLinkProps.onClick = this.onNavLinkClick;
    });

    return (
      <nav id="siteNavbar" className="site-navbar" tabIndex={-1}>
        <div className="row">
          <div className="col-nav-menu">
            <NavMenu menu={navMenu} />
          </div>
        </div>
      </nav>
    );
  }

  public onNavLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void {
    const elCurrentTarget = event.currentTarget;
    if (elCurrentTarget == null) {
      return;
    }

    //const { onClick: onClickProp } = this.props;
    const key = elCurrentTarget.getAttribute('data-key') as string;
    //const clickHandler = onClickProp && Object.prototype.hasOwnProperty.call(onClickProp, key) && onClickProp[key];
    //const callClickHandler = () => AppUtils.isFunction(clickHandler) && clickHandler(event);

    const eventName = `Click ${AppUtils.jsPropertyNameToTitleCase(key)} Menu Item`;
    this.trackEvent(eventName)
    
  }

  // tslint:disable-next-line:no-any
  private trackEvent(eventName: string, props?: { [key: string]: any }) {
    const pageTitle = getDocumentTitle(window.location.pathname, { lng: LANGUAGE_CODE_EN_CA });
    const properties = Object.assign({}, { [MIXPANEL_PROPERTY_PAGE_TITLE]: pageTitle }, props);
    AppInsightsService.trackEvent({ name: eventName, properties });
   // return MixpanelService.track(eventName, properties);
  }
}

const SiteNavbar = translate('global', { i18n })(SiteNavbarComponent);
export default SiteNavbar;
